import { render, staticRenderFns } from "./MainProgress.vue?vue&type=template&id=2e0d9a0c&scoped=true&"
var script = {}
import style0 from "./MainProgress.vue?vue&type=style&index=0&id=2e0d9a0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d9a0c",
  null
  
)

export default component.exports